/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */

import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import fb from 'firebaseConfig';
import PATH from 'routes/path';
import {
  getCustomers,
} from 'services/api/customers';
import { AuthContext } from 'providers/AuthProvider';
import { CustomizedSteppers } from 'components/Stepper';

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const { currentUser } = useContext(AuthContext);
  const pathName = window.location.pathname;
  const [idCase, setIdcase] = useState(0);

  // Carrega os dados do usuário (customer)
  const loadCustomer = async () => {
    try {
      const { data } = await getCustomers();
      data[0].meta_data.idCase && setIdcase(data[0].meta_data.idCase);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.Intercom('update', {
      hide_default_launcher: true,
    });
  }, []);

  useEffect(() => {
    loadCustomer();
  }, [pathName]);

  const logout = () => {
    if (localStorage.getItem('webview')) {
      localStorage.clear();
      localStorage.setItem('webview', 'true');
    } else {
      localStorage.clear();
    }
    fb.auth().signOut();
  };

  /* VERIFICA SE ESTAMOS EM MANUTENÇÃO */
  if (process.env.REACT_APP_MAINTENANCE === 'true') {
    logout();
    return (
      <Redirect to={PATH.MAINTENANCE} />
    );
  }

  // Redireciona para /login caso não esteja logado
  return (
    <Route
      {...rest}
      render={
        (routeProps) => (currentUser
          ? (
            pathName === PATH.HOME ? <RouteComponent {...routeProps} />
              : (
                <>
                  <CustomizedSteppers idCase={idCase} />
                  <RouteComponent {...routeProps} />
                </>
              )
          )
          : (<Redirect to={PATH.LOGIN} />)
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

export default PrivateRoute;
